import { useRouter } from '@/hooks';
import { TemplatesList } from '@/components/TemplateBuilder/TemplatesList';
import { DefaultLayout } from '@/layouts';
import { selectedStructureId as structureIdState } from '@/state';
import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

export const TemplateBuilderListPage = () => {
  const setStructureId = useSetAtom(structureIdState);
  const router = useRouter();
  const { structure } = router.query;
  useEffect(() => {
    if (structure && !Array.isArray(structure)) {
      setStructureId(structure);
    }
  });

  if (!structure || Array.isArray(structure)) {
    return <div>Please specify structure id</div>;
  }

  return (
    <DefaultLayout>
      <TemplatesList structureId={structure} />
    </DefaultLayout>
  );
};
